import {siteInfoState, siteNavState} from '@/stores/site/atom';

const siteState = {
  siteInfoState,
  siteNavState,
};

export default siteState;
